
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"29","height":"28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.002 11.59l-.03-.13-.12.06c-.54.3-1.13.49-1.75.56l-.11.01.02.11c.07.33.11.68.11 1.02 0 1.64-.83 3.18-2.34 4.34-1.52 1.17-3.54 1.81-5.68 1.81-1.03 0-2.05-.16-3.03-.47l-.89-.28-.05-.02-.8.57c-.62.44-1.28.79-1.97 1.03.27-.46.48-.92.65-1.35l.41-1.1.02-.06-.85-.9c-.7-.74-1.53-1.97-1.53-3.58 0-1.63.83-3.18 2.34-4.34 1.52-1.17 3.54-1.81 5.68-1.81.97 0 1.92.13 2.82.39l.12.04.01-.13c.02-.62.17-1.22.43-1.78l.05-.11-.11-.03c-1.05-.29-2.16-.44-3.3-.44-5.57 0-10.1 3.69-10.1 8.23 0 1.8.71 3.51 2.05 4.96-.3.76-.75 1.46-1.08 1.92-.2.28-.37.49-.48.62-.06.07-.11.13-.15.17l-.04.03h-.03v.03c-.27.3-.35.74-.19 1.11.16.38.54.63.96.63 2.38 0 4.28-.97 5.45-1.8 1.17.36 2.39.55 3.61.55 5.57 0 10.1-3.69 10.1-8.22 0-.56-.07-1.11-.2-1.64z","fill":"#313131"}}),_c('path',{attrs:{"d":"M21.5 11a3.5 3.5 0 100-7 3.5 3.5 0 000 7z","fill":"#FF4954"}})])
          )
        }
      }
    